module.exports = {"apiUrl":"https://shadow-tech-dream-job-api.be.shadowtechllc.net","brandId":"dreamjob"};